import { Product } from '../graphql/entities';
import { IOrderConfig, Maybe } from '../graphql/schema/p4types';
import { EntityType } from '../@types/entityTypes';

export type GridExtendedEntityType = EntityType & {
  searchTabOffset?: { xOffset: number; yOffset: number };
  searchEnterOffset?: { xOffset: number; yOffset: number };
};

export default function productDropdown(orderConfig?: Maybe<IOrderConfig>) {
  const extendedProduct: GridExtendedEntityType & {
    searchTabOffset?: { xOffset: number; yOffset: number };
    searchEnterOffset?: { xOffset: number; yOffset: number };
  } = Product;

  switch (orderConfig?.searchTabBehaviour) {
    case 'NEXT_ROW':
      extendedProduct.searchTabOffset = { xOffset: 0, yOffset: 1 };
      break;
    case 'EDIT_QUANTITY':
    default:
      extendedProduct.searchTabOffset = { xOffset: 2, yOffset: 0 };
  }

  switch (orderConfig?.searchEnterBehaviour) {
    case 'NEXT_ROW':
      extendedProduct.searchEnterOffset = { xOffset: 0, yOffset: 1 };
      break;
    case 'EDIT_QUANTITY':
    default:
      extendedProduct.searchEnterOffset = { xOffset: 2, yOffset: 0 };
  }

  return extendedProduct;
}
